<div class="card-messages card-messages--success" *ngIf="successMessages.length > 0">
  <span class="card-messages__close card-messages__close--success" (click)="successMessages=[]">&times;</span>
  <span id="card-messages.success" data-cy="card-messages-success" class="card-messages__msg"
    *ngFor="let successMessage of successMessages">
    {{successMessage}}
  </span>
</div>
<div class="card-messages card-messages--error" *ngIf="errorMessages.length > 0">
  <span class="card-messages__close card-messages__close--error" (click)="errorMessages=[]">&times;</span>
  <span id="card-messages.multiple-errors" class="card-messages__msg bold" *ngIf="errorMessages.length > 1">There were
    {{errorMessages.length}} errors with your submission</span>
  <span id="card-messages.error" data-cy="card-messages-error" class="card-messages__msg"
    [ngClass]="{'card-messages__msg--list': errorMessages.length > 1}" *ngFor="let errorMessage of errorMessages">
    {{errorMessage}}
  </span>
</div>
<div class="card-messages card-messages--warning" *ngIf="warningMessages.length > 0">
  <span class="card-messages__close card-messages__close--warning" (click)="warningMessages=[]">&times;</span>
  <span id="card-messages.warning" data-cy="card-messages-warning" class="card-messages__msg"
    *ngFor="let warningMessage of warningMessages">
    {{warningMessage}}
  </span>
</div>